import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";

export interface TalentType {
  result: any;  
}

export const QUERY_KEY_FOR_JOBS = "recommended-jobs";

const getJobsData = async (token: string): Promise<TalentType[]> => {
    const url = `${END_POINT.BASE_URL}/v1/dashboardtr`;
    const config = {
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        },
    };

    const res = await axios.get(url, config);
    return res.data;
};

export const useGetRecommendedJobs = (token: string) => {
    return useQuery(
        [QUERY_KEY_FOR_JOBS],
        () => getJobsData(token),
        {
            enabled: !!token,
            staleTime: 5 * 60 * 1000,
        }
    );
};